module.exports = __webpack_public_path__ + "static/lead-background-c2f2d6658f6285d4bb9d10c3743a751c.jpg";